const deployedURL = "https://vchat-bot.netlify.com/"
const apiURL = "https://1vex996e96.execute-api.us-east-1.amazonaws.com/dev"

export { deployedURL, apiURL };